import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getChallengeTypes } from './thunks'

const initialState: ChallengeTypesState = {
  types: [],
  status: 'idle',
  error: null,
}

const slice = createSlice({
  name: 'challengeTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChallengeTypes.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getChallengeTypes.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getChallengeTypes.fulfilled, (state, action) => {
        state.status = 'succeeded'
        if (action.payload.data) {
          state.types = action.payload.data
        }
      })
  },
})

export const selectChallengeTypes = (state: RootState): ChallengeTypesState => state.challengeTypes

export default slice.reducer
